<template>
  <footer class="site-footer">
    <div class="mobile">
      <div class="content-max-width flex">
        <ul>
          <li v-for="(link, index) of data.left" :key="index">
            <a :href="link.url">{{ link.title }}</a>
          </li>
        </ul>
        <ul>
          <li v-for="(link, index) of data.right" :key="index">
            <a :href="link.url">{{ link.title }}</a>
          </li>
        </ul>
      </div>  
    </div>
    <div class="content-max-width flex">
      <p class="copyright">© Fyers Joyce 2021</p>
      <a
        href="http://www.brownpaperbag.co.nz/"
        target="_blank"
        class="attribution"
      >Web design by Brownpaperbag</a>
    </div>
  </footer>
</template>

<script>
export default {
  props: [
    'data'
  ],
};
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue